import 'pusher-js'
import Echo from 'laravel-echo'
import addiesaas from '~/addiesaas'
import * as authMutationTypes from 'system/authentication/vuexstore/mutation-types'

const client = {
    connect(authToken) {
        if (this.echo) {
            throw new Error('Already connected')
        }

        this.echo = new Echo({
            broadcaster: 'pusher',
            key: addiesaas.config.pusher.key,
            cluster: addiesaas.config.pusher.cluster,
            namespace: 'App.Containers.Social.Notifications.Events',
            auth: {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                },
            },
        })

        this.channels = {}
    },

    subscribeChannel(channelName) {
        if (this.channels[channelName]) {
            throw new Error(`Already subscribed to channel '${channelName}'`)
        }

        this.channels[channelName] = this.echo.private(channelName)
    },

    listen(channelName, eventName, callback) {
        this.channels[channelName].listen(eventName, callback)
    },

    leaveChannel(channelName) {
        if (this.channels[channelName]) {
            this.echo.leave(channelName)
            this.channels[channelName] = null
        }
    },

    leaveAllChannels() {
        Object.keys(this.channels).forEach(channelName => {
            this.leaveChannel(channelName)
        })
    },

    disconnect() {
        if (this.echo) {
            this.echo.disconnect()
        }
        this.echo = null
    },
}

const store = {
    getUser() {
        return addiesaas.store.getters.authUser
    },
    getAuthToken() {
        return addiesaas.store.getters.authToken
    },
    subscribeUser(callback) {
        addiesaas.store.subscribe(m => {
            if (m.type == authMutationTypes.FETCH_USER_SUCCESS || m.type == authMutationTypes.LOGOUT) {
                callback()
            }
        })
    },
    setCounters(counters) {
        addiesaas.store.dispatch('SocialNotifications/General/setNotificationCounters', counters)
    },
}

store.subscribeUser(() => {
    client.disconnect()

    const user = store.getUser()
    
    if (user) {
        client.connect(store.getAuthToken())

        const channelName = `social-notifications.${user.id}`

        client.subscribeChannel(channelName)

        client.listen(channelName, 'NotificationCountersUpdateEvent', (e) => {
            store.setCounters(e)
        })
    }
    else {
        store.setCounters({})
    }
})
